import React from 'react';
import { useSlate, ReactEditor } from 'slate-react';
import { Editor, Transforms, Element as SlateElement, Range } from 'slate';
import { useSelected } from 'slate-react';
import escapeHtml from 'escape-html';

import { CheckListItemElement } from './check-list';
import { Image } from './images';
import elementTypes from '../elements/types';
import HelptapEditor from '../helpers';

const LIST_TYPES = ['numbered-list', 'bulleted-list'];

const unwrappableTypes = [
  ...LIST_TYPES,
  elementTypes.TOGGLE_LIST_HEAD
];

const isBlockActive = (editor, format) => {
  const { selection } = editor
  if (!selection) return false

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: n =>
        !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === format,
    })
  )

  return !!match
}

export function toggleBlock(editor, format, blockOptions = {}) {

  const isActive = isBlockActive(editor, format);
  const isList = LIST_TYPES.includes(format);

  Editor.withoutNormalizing(editor, () => {
    Transforms.unwrapNodes(editor, {
      match: n => !Editor.isEditor(n) &&
        SlateElement.isElement(n) &&
        unwrappableTypes.includes(n.type),
      split: true,
    });

    const newProperties = {
      ...HelptapEditor.baseNode.getDefaultOptions(),
      ...blockOptions
    };

    if (isActive === true) {

      newProperties.type = 'paragraph';

    } else if (isList === true) {

      if (format === elementTypes.NUMBERED_LIST) {
        newProperties.type = elementTypes.NUMBERED_LIST_ITEM;
      } else {
        newProperties.type = elementTypes.BULLETED_LIST_ITEM;
      }

    } else {

      newProperties.type = format;

    }

    Transforms.setNodes(editor, newProperties);

    if (isActive === false && isList === true) {

      const block = {
        ...HelptapEditor.baseNode.getDefaultOptions(),
        ...blockOptions,
        type: format,
        children: []
      };

      Transforms.wrapNodes(editor, block);

    }
  });

  ReactEditor.focus(editor);

}

export function insertLink(editor, url) {

  if (typeof editor.selection === 'undefined') {
    return;
  }

  wrapLink(editor, url);

}

function isLinkNode(node) {

  return !Editor.isEditor(node) && SlateElement.isElement(node) && node.type === 'link';

}

function isLinkActive(editor) {

  const [link] = Editor.nodes(editor, {
    match: isLinkNode
  });

  return !!link;

}

export function unwrapLink(editor) {

  Transforms.unwrapNodes(editor, {
    match: isLinkNode
  });

}

export function wrapLink(editor, url) {

  if (isLinkActive(editor) === true) {
    unwrapLink(editor);
  }

  const { selection } = editor;

  const isCollapsed = selection && Range.isCollapsed(selection);
  const link = {
    type: 'link',
    url,
    children: []
  };

  if (isCollapsed === true) {
    link.children = [{ text: url }];
  }

  if (isCollapsed === true) {
    Transforms.insertNodes(editor, link);
  } else {
    Transforms.wrapNodes(editor, link, { split: true });
    Transforms.collapse(editor, { edge: 'end' });
  }

  ReactEditor.focus(editor);

}